import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", { for: "filter" }, "Filter", -1)

import { Mutations } from "@/store";
import { ref } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'Filter',
  setup(__props) {

const input = ref(null);
const store = useStore();
const filter = ref<string>(store.state.filter);

const update = (evt: Event) => {
  store.commit(Mutations.UpdateFilter, filter.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(update, ["prevent"]),
    class: "filter field inline"
  }, [
    _hoisted_1,
    _withDirectives(_createElementVNode("input", {
      id: "filter",
      ref_key: "input",
      ref: input,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter).value = $event)),
      onKeydown: update,
      onKeyup: update
    }, null, 544), [
      [_vModelText, filter.value]
    ])
  ], 32))
}
}

})